<template>
  <div class="dara-layout">
    <div class="dara-layout__topbar">
      <dara-topbar />
    </div>
    <div v-if="tag" class="dara-layout__body-container">
      <div class="dara-layout__body">
        <div class="dara-layout__content">
          <div class="dara-layout__content__latest-articles">
            <div class="d-flex align-items--center">
              <dara-header>
                #{{ tag.name }}
              </dara-header>
              <div class="ms-4 mt-3">
                <dara-button
                  v-if="!following"
                  class="btn btn-success mb-3"
                  size="sm"
                  @click="follow(tag)">
                  {{ $t('follow') }}
                </dara-button>
                <dara-button
                  v-if="following"
                  class="btn btn-danger mb-3"
                  size="sm"
                  @click="unfollow(tag)">
                  {{ $t('unfollow') }}
                </dara-button>
              </div>
            </div>
            <dara-tag-articles-and-questions
              ref="tagArticleQuestions"
              :tag="tag"
              @deleteQuestion="deleteQuestion" />
          </div>
        </div>
        <div class="dara-layout__sidebar">
          <div class="dara-layout__sidebar__trending-tags">
            <dara-tag-sidebar />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchTagById, followTag, unfollowTag, getTagUser } from '@/modules/tag/tag.service';
import { toastSuccess, toastError } from '@/services/toastService';
import { removeQuestion } from '@/modules/question/question.service';
import { translate } from '@/services/translate.service';

import DaraTagSidebar from '@/modules/tag/components/TagSidebar.vue';
import DaraTagArticlesAndQuestions from '@/modules/tag/components/TagArticlesAndQuestions.vue';

export default {
  name: 'DaraTagViewPage',
  components: {
    DaraTagArticlesAndQuestions,
    DaraTagSidebar,
  },
  data() {
    return {
      tag: null,
      following: false,
    };
  },
  computed: {
    id() {
      return this.$route.params?.id;
    },
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch() {
      fetchTagById(this.id)
        .then(({ data }) => {
          this.tag = data;
          getTagUser(this.tag)
            .then(response => {
              this.following = ((response.length) ? 1 : 0);
            })
            .catch(() => toastError(`${translate('error-getting-tag-user-relation')}`));
        })
        .catch(() => toastError(`${translate('error-getting-tag')}`));
    },
    follow(tag) {
      followTag(tag)
        .then(() => {
          this.following = true;
        })
        .catch(() => toastError(`${translate('error-following-tag')}`));
    },
    unfollow(tag) {
      unfollowTag(tag)
        .then(() => {
          this.following = false;
        })
        .catch(() => toastError(`${translate('error-unfollowing-tag')}`));
    },
    deleteQuestion(question) {
      removeQuestion(question)
        .then(() => {
          this.$refs.tagArticleQuestions.fetch();
          this.fetch();
          toastSuccess(`${translate('question-removed')}`);
        })
        .catch(() => toastError(`${translate('error-removing-the-question')}`));
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/bootstrap/variables';
@import 'bootstrap/scss/mixins';
@import 'bootstrap/scss/containers';
@import '@/scss/variables/colors';
@import '@/scss/variables/margins';
@import '@/scss/variables/paddings';

.dara-layout {
  height: 100vh;
  display: grid;
  overflow: hidden;
  grid-template-rows: auto 1fr;

  .dara-layout__body-container {
    display: grid;
    overflow-y: auto;

    .dara-layout__body {
      @extend .container-xxl;
      display: grid;
      grid-template-columns: 400px 1fr;

      @include media-breakpoint-down(md) {
        grid-template-rows: 1fr 1fr;
        grid-template-columns: 1fr;
      }
    }

    .dara-layout__sidebar {
      order: 1;
      display: grid;
      border-right: 1px solid $border-light-color;
      grid-template-rows: auto auto 1fr;

      & > * {
        padding: $padding-xl;
      }

      @include media-breakpoint-down(md) {
        order: 2;
      }
    }

    .dara-layout__content {
      order: 2;
      display: grid;
      grid-template-rows: 1fr;

      & > * {
        padding: $padding-xl;

        @include media-breakpoint-down(md) {
          padding: $padding-lg;
        }
      }

      @include media-breakpoint-down(md) {
        order: 1;
      }
    }
  }
}
</style>
